export default "__VITE_ASSET__b6757957__"